import React, { Component, useEffect, useState } from "react";

// table(components)
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import BoostrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { PageOptions } from "../../components/PageParams";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setReminder } from "../../../features/UserActions";
import { HttpJsonHeader } from "../../../features/Environments";

import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

import { AiOutlinePlus, AiFillEdit, AiOutlineDelete } from "react-icons/ai";
import ConfirmDialog, { GetConfirmTitle } from "../../components/ConfirmDialog";
import styled from "styled-components";
import BranchWardPopup from "./BranchWardPopup";
import { GetCreateTable } from "../../../core/Helper2";
import { GetHeaderStyle, GetNormalStyle } from "../../../core/Helper";

export default function BranchWard(props) {
  // ** UserInfo + Popup Message ***/
  const userDetail = useSelector((state) => state.user.detail);
  const dispatch = useDispatch();
  // ** Main State ***/
  const [patrightEditor, setPatrightEditor] = useState({
    show: false,
    action: null,
  });
  const [data, setData] = useState([]);
  const [dataX, setDataX] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [updateFlag, setUpdateFlag] = useState(true);
  //----------------------------------------------------------------------
  useEffect(() => {
    if (updateFlag) {
      getData();
      setUpdateFlag(false);
    }
  }, [updateFlag]);
  //----------------------------------------------------------------------
  // ** List All rows
  const getData = async () => {
    await axios
      .post(
        process.env.REACT_APP_API + "api/branchward/list-data",
        {
          UserInfo: userDetail,
          SearchTxt: "",
        },
        HttpJsonHeader
      )
      .then((res) => {
        setData(res.data && res.data.rows);
      })
      .catch((err) =>
        dispatch(setReminder({ show: true, message: err.message }))
      );
  };
  //----------------------------------------------------------------------
  // Actions
  // Save new Action
  const openNew = () => {
    setPatrightEditor({
      show: true,
    });
  };

  const actionNewData = () => {
    setSelectedRow({
      row: { brchwardid: 0 },
      action: openNew,
    });
  };
  // Update Action
  const actionUpdate = (row) => {
    setSelectedRow({
      row: { ...row },
      action: openNew,
    });
  };
  // Delete Action
  const actionDelete = (row) => {
    setShowConfirm(true);
    setConfirmAction({
      title: GetConfirmTitle("DELETE"),
      data: row,
      action: (row) => {
        let dataToUpdate = { ItemInfo: row, UserInfo: userDetail };
        axios
          .post(
            process.env.REACT_APP_API + "api/branchward/delete",
            dataToUpdate,
            HttpJsonHeader
          )
          .then((res) => {
            setUpdateFlag(true);
            dispatch(
              setReminder({
                show: true,
                message: "ยกเลิกเรียบร้อย",
                type: "success",
              })
            );
          })
          .catch((err) => {
            dispatch(
              setReminder({ show: true, message: err.message, type: "error" })
            );
          });
      },
    });
  };

  //----------------------------------------------------------------------
  //columns
  const getHeaderStyle = (wi) => {
    return {
      width: wi,
      background: "var(--table-header-back-color)",
    };
  };
  //----------------------------------------------------------------------
  const customTextFilter = {
    placeholder: "...",
  };
  //----------------------------------------------------------------------
  const formatEditBox = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>แก้ไข</Tooltip>}
        >
          <Button
            variant="info"
            className="info-button"
            onClick={() => actionUpdate(row)}
          >
            <AiFillEdit />
          </Button>
        </OverlayTrigger>

        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>ลบ</Tooltip>}
        >
          <Button
            variant="danger"
            className="info-button"
            onClick={() => {
              actionDelete(row);
            }}
          >
            <AiOutlineDelete />
          </Button>
        </OverlayTrigger>
      </div>
    );
  };
  //----------------------------------------------------------------------
  // ** Columns List
  const columns = [
    {
      dataField: "ward_code",
      text: "รหัสแผนก",
      sort: true,
      headerStyle: () => GetHeaderStyle("20%"),
      style: GetNormalStyle("center"),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "ward_name",
      text: "ชื่อแผนก",
      sort: true,
      headerStyle: () => GetHeaderStyle("auto"),
      style: GetNormalStyle("left"),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "ward_short",
      text: "ชื่อสั้น",
      sort: true,
      headerStyle: () => GetHeaderStyle("30%"),
      style: GetNormalStyle("left"),
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "box",
      text: "",
      isDummyField: true,
      headerStyle: () => GetHeaderStyle("120px"),
      style: GetNormalStyle("center"),
      formatter: formatEditBox,
    },
  ];

  //----------------------------------------------------------------------
  return (
    <div class="tab-content-worklist center-box-new">
      <HBox>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>เพิ่มข้อมูลใหม่</Tooltip>}
        >
          <button class="btn-blue" onClick={() => actionNewData()}>
            <AiOutlinePlus /> เพิ่มข้อมูลใหม่
          </button>
        </OverlayTrigger>

        <div className="table-caption-box-right-flex">{"Ward"}</div>
      </HBox>
      {GetCreateTable({
        idFieldName: "pacs_study_id",
        columns,
        data,
      })}

      <BranchWardPopup
        {...{
          winState: [patrightEditor, setPatrightEditor],
          selectedRow,
          dataX,
          setDataX,
          setUpdateFlag,
        }}
      />
      <ConfirmDialog
        {...{ showConfirm, setShowConfirm, confirmAction, setConfirmAction }}
      />
    </div>
  );
}

const HBox = styled.div`
  padding: 0px;
  display: flex;
`;
